import { render, staticRenderFns } from "./PODetailModal.vue?vue&type=template&id=32c87286&scoped=true"
import script from "./PODetailModal.vue?vue&type=script&lang=ts"
export * from "./PODetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PODetailModal.vue?vue&type=style&index=0&id=32c87286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c87286",
  null
  
)

export default component.exports